import React from 'react';
import PropTypes from 'prop-types';

const SuccessCheckmark = ({ borderless, width, className, fill }) => {
  const border = (
    <path
      className={className}
      fill={fill}
      d="M77.333 40C77.333 19.381 60.62 2.667 40 2.667S2.667 19.38 2.667 40 19.38 77.333 40 77.333 77.333 60.62 77.333 40zM0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z"
      fillRule="nonzero"
    />
  );

  return (
    <svg width={width} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
      <title>checkmark</title>
      <g fill="none" fillRule="evenodd">
        {borderless ? null : border}
        <g id="check-icon" transform="translate(10.000000, 10.000000)">
          <rect id="bounds" x="0" y="0" width="60" height="60" />
          <polygon
            className={className}
            fill={fill}
            id="Shape"
            points="22.4999847 40.5 11.9999847 30 8.49998475 33.5000001 22.4999847 47.4999999 52.4999847 17.5 48.9999846 14"
          />
        </g>
      </g>
    </svg>
  );
};

SuccessCheckmark.defaultProps = {
  width: '80',
  borderless: false,
  className: '',
  fill: '#000000',
};

SuccessCheckmark.propTypes = {
  width: PropTypes.string,
  borderless: PropTypes.bool,
  className: PropTypes.string,
  fill: PropTypes.string,
};

export default SuccessCheckmark;
